import { render, staticRenderFns } from "./NewProductAddToCategory.vue?vue&type=template&id=65dabb43"
import script from "./NewProductAddToCategory.vue?vue&type=script&lang=js"
export * from "./NewProductAddToCategory.vue?vue&type=script&lang=js"
import style0 from "./NewProductAddToCategory.vue?vue&type=style&index=0&id=65dabb43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports